<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<div *ngIf="dataLoaded$ | async" class="events-container" appLifecycleTracker trackerName="event-viewer">
    <div id="search" class="events-search-container">
        <div class="events-search">
            <mat-form-field appearance="outline">
                <input placeholder="{{fPlaceholder}}"
                       matInput
                       class="event-search-box"
                       id="event-search-box"
                       appDebounceInput
                       debounceTime="500"
                       (debounceInput)="refreshEventsViewer()"
                       (keyup)="onSearchKeyUp($event.target.value)"
                       maxlength="255"
                />
            </mat-form-field>
        </div>
        <div class="events-time">
            <mat-form-field appearance="outline">
                <mat-label>{{fTimeFilter}}</mat-label>
                <mat-select [(ngModel)]="selectedTime" name="time" (selectionChange)="onTimeChange($event)">
                    <mat-option *ngFor="let time of times" [value]="time.value">
                        {{time.displayValue}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>
        <div class="button-container">
            <button mat-flat-button color="primary" style="margin-right: 1em"
                    (click)="exportCSV()">{{fExportCSV}}</button>
            <button mat-flat-button color="primary" (click)="exportJSON()">{{fExportJSON}}</button>
        </div>
    </div>
    <div class="event-content" id="event-content">
        <div class="filter-selector-container" id="control">
            <div id="sourceType">
                <mat-form-field class="filter-selector" appearance="outline">
                    <mat-label>{{fSourceFilter}}</mat-label>
                    <mat-select [formControl]="sourcesForm" multiple (selectionChange)="onSourceChange($event)">
                        <mat-select-trigger>
                            {{sourcesForm.value != undefined && sourcesForm.value.length > 0 ? sourcesForm.value[0].displayValue : ''}}
                            <span *ngIf="sourcesForm.value?.length > 1" class="additional-selection">
                                    (+{{sourcesForm.value.length - 1}} {{sourcesForm.value?.length === 2 ? 'other' : 'others'}}
                                )
                                </span>
                        </mat-select-trigger>
                        <mat-option *ngFor="let sourceType of sourceTypes"
                                    [value]="sourceType">{{sourceType.displayValue}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div id="event-types">
                <mat-form-field class="filter-selector" appearance="outline">
                    <mat-label>{{fEventFilter}}</mat-label>
                    <mat-select [formControl]="eventTypeForm" multiple (selectionChange)="onEventTypeChange($event)" [panelWidth]="null">
                        <mat-select-trigger>
                            {{eventTypeForm.value != undefined && eventTypeForm.value.length > 0 ?
                            eventTypeForm.value[0] :
                            ''}}
                            <span *ngIf="eventTypeForm.value?.length > 1" class="additional-selection">
                                    (+{{eventTypeForm.value.length - 1}} {{eventTypeForm.value?.length === 2 ? 'other' : 'others'}}
                                )
                                </span>
                        </mat-select-trigger>
                        <mat-option *ngFor="let eventType of eventTypes" id="event-type"
                                    [value]="eventType">{{eventType}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <div id="severity">
                <mat-form-field class="filter-selector" appearance="outline">
                    <mat-label>{{fSeverityFilter}}</mat-label>
                    <mat-select [formControl]="severityForm" [multiple]="false"
                                (selectionChange)="onSeverityChange($event)">
                        <mat-select-trigger>
                            {{severityForm.value != undefined && severityForm.value.value > 0 ? severityForm.value.displayValue : ''}}
<!--                            <span *ngIf="severityForm.value" class="additional-selection">
                                (+{{severityForm.value.length - 1}} {{severityForm.value?.length === 2 ? 'other' : 'others'}})
                            </span>-->
                        </mat-select-trigger>
                        <mat-option *ngFor="let severity of severities"
                                    [value]="severity">{{severity.displayValue}}</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
        </div>
        <div *ngIf="totalResults > 0; else noData" class="table-container" id="table-total-results">
            <div class="cigent-box-container">
                <div id="totalResults" class="total-results-wrapper">
                    <b>{{totalResults | number}} {{fEventNumber}} </b>
                </div>
                <app-column-chooser class="column-chooser" saveId="events" [elements]="columns"
                                    (change)="updateDisplayedColumns($event)"></app-column-chooser>
            </div>
            <div class="table-wrapper" id="table" (scroll)="onScrollHandler($event)">
                <table mat-table [dataSource]="eventsData" matSort matSortDisableClear='true'
                       matSortActive="timestamp" matSortStart="desc" matSortDirection="desc"
                       (matSortChange)="sortColumn($event)" aria-describedby="Events table">
                    <ng-container matColumnDef="timestamp">
                        <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{fTimestamp}}</th>
                        <td mat-cell *matCellDef="let event"> {{event.timestamp | date : 'medium' }} </td>
                    </ng-container>
                    <ng-container matColumnDef="groupName">
                        <th scope="col" mat-header-cell *matHeaderCellDef matSortDisabled>{{fGroup}}</th>
                        <td mat-cell *matCellDef="let event"> {{event.groupName}} </td>
                    </ng-container>
                    <ng-container matColumnDef="username">
                        <th scope="col" mat-header-cell *matHeaderCellDef matSortDisabled>{{fUser}}</th>
                        <td mat-cell *matCellDef="let event"> {{event.username}} </td>
                    </ng-container>
                    <ng-container matColumnDef="integrationName">
                        <th scope="col" mat-header-cell *matHeaderCellDef matSortDisabled>{{fIntegration}}</th>
                        <td mat-cell *matCellDef="let event"> {{event.integrationName}} </td>
                    </ng-container>
                    <ng-container matColumnDef="severity">
                        <th scope="col" mat-header-cell *matHeaderCellDef matSortDisabled>{{fSeverity}}</th>
                        <td mat-cell *matCellDef="let event"> {{event.severityDisplay}} </td>
                    </ng-container>
                    <ng-container matColumnDef="type">
                        <th scope="col" mat-header-cell *matHeaderCellDef matSortDisabled>{{fEvent}}</th>
                        <td mat-cell *matCellDef="let event"> {{event.type}} </td>
                    </ng-container>
                    <ng-container matColumnDef="source">
                        <th scope="col" mat-header-cell *matHeaderCellDef matSortDisabled>{{fSource}}</th>
                        <td mat-cell *matCellDef="let event"> {{event.sourceDisplay}} </td>
                    </ng-container>
                    <ng-container matColumnDef="description">
                        <th scope="col" mat-header-cell *matHeaderCellDef matSortDisabled>{{fDescription}}</th>
                        <td mat-cell *matCellDef="let event"> {{event.description}} </td>
                    </ng-container>
                    <ng-container matColumnDef="detail">
                        <th scope="col" mat-header-cell *matHeaderCellDef matSortDisabled>{{fDetail}}</th>
                        <td mat-cell *matCellDef="let event"> {{event.detail}} </td>
                    </ng-container>
                    <ng-container matColumnDef="data">
                        <th scope="col" mat-header-cell *matHeaderCellDef matSortDisabled>{{fData}}</th>
                        <td mat-cell *matCellDef="let event"> {{event.data}} </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true"></tr>
                    <tr mat-row *matRowDef="let myRowData; columns: columnsToDisplay"></tr>
                </table>
            </div>
        </div>
        <ng-template #noData>
            <div id="totalResults" style="height: 100px;" class="no-data">
                <span class="no-data">{{fNone}}</span>
            </div>
        </ng-template>
    </div>
</div>
